<div class="graphic-container">
    <ngx-slider [options]="sliderOptions" [value]="initialLowValue" [highValue]="initialHighValue" (userChange)="sliderChange($event)" ></ngx-slider>
    <div class="legend-container">
        <div class="label-container fast-label-container">
            <span class="fast-label">{{ 'routeForm.fast' | transloco }}: {{fast()}}%</span>
            <div [style.width]="fast()+'%'" class="legend-color"></div>
        </div>
        <div class="label-container withoutHills-label-container">
            <span class="withoutHills-label">{{ 'routeForm.withoutHills' | transloco }}: {{flat()}}%</span>
            <div [style.width]="flat()+'%'" class="legend-color"></div>
        </div>
        <div class="label-container adaptedToBicycles-label-container">
            <span  class="adaptedToBicycles-label">{{ 'routeForm.adaptedToBicycles' | transloco }}: {{bicycleAdapted()}}%</span>
            <div [style.width]="bicycleAdapted()+'%'" class="legend-color"></div>
        </div>
    </div>
</div>
